export function hasCssClass(element: HTMLElement, className: string): boolean {
	if (!element || !className) {
		return false;
	}
	return element.classList.contains(className);
}
